import axios from 'axios'
import { Message } from 'element-ui' // 引入 ElementUI 的 Message 组件
import store from '@/store'
// 创建 axios 实例
const service = axios.create({
  // baseURL: 'http://nvivo.spss-ai.com/api/', // 测试环境地址
  baseURL: 'https://nvivoai.statistical-analysis.top/api', // 测试环境地址
  // baseURL: 'http://nvivo.spss-ai.com/api', // 测试环境地址
  // baseURL: '127.0.0.1:8000/api/',
  // 如果有需要,可添加请求超时时间
  timeout: 500000,
  // 禁用缓存，确保每次都获取最新数据
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
})

// 导出 baseURL 供其他模块使用
export const baseURL = service.defaults.baseURL

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 从本地存储中获取用户信息
    const userStr = localStorage.getItem('user')

    if (userStr) {
      const user = JSON.parse(userStr).user || {}

      // 如果有 token，则在请求头中添加 Authorization
      if (user.token) {
        // 注意使用 "Authorization"（首字母大写 A）更通用
        config.headers.authorization = `Bearer ${user.token}`
      }
    }

    return config
  },
  (error) => {
    // 可以在这里对请求错误进行统一处理
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 直接返回后端返回的数据,或根据需要定制
    return response.data
  },
  (error) => {
    // 获取错误状态码
    const status = error.response?.status
    // 获取后端错误信息,若无则显示"网络请求错误"
    const msg = error.response?.data?.message || '网络请求错误'

    if (status === 401) {
      // 针对 401 未授权的场景
      Message.error('登录已过期,请重新登录')
      
      // 清除 Vuex state
      store.commit('user/CLEAR_USER')
      
      // 清除 localStorage 中的持久化数据(vuex-persistedstate)
      localStorage.removeItem('user')
      localStorage.removeItem('my_site_vuex')
    } else {
      // 其他错误提示
      Message.error(msg)
    }

    return Promise.reject(error)
  }
)

// 导出 axios 实例
export default service
